class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');    
  }
  onSubmitHandler(evt) {
      evt.preventDefault();
      var uniq_varid = $('.uniq_proid').val(); 
      var main_this = this;
      //console.log(uniq_varid);
      var data_qtylimit = $('.qty_size_limit').data('qty');
      var p_submitform = true;

      function cartformsubmit(){
        main_this.cartNotification.setActiveElement(document.activeElement);        

        const submitButton = main_this.querySelector('[type="submit"]');

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const body = JSON.stringify({
          ...JSON.parse(serializeForm(main_this.form)),
          sections: main_this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
        
        const body_sec = {
          ...JSON.parse(serializeForm(main_this.form)),
          sections: main_this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:body_sec,
          dataType: 'json',
          beforeSend: function(){

          },
          success: function(parsedState){
            ajaxCart.load();
            main_this.cartNotification.renderContents(parsedState);  
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            $('.top_btnlist').hide();
            $('.pick_only_size').removeClass('active');
          },
          error: function(XMLHttpRequest, textStatus){
            $('.btnpro_error').text(XMLHttpRequest.responseJSON.description);
            setTimeout(function(){
              $('.btnpro_error').empty();
            },3000);
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          }
        });                
        /*fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          main_this.cartNotification.renderContents(parsedState);          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
                 ajaxCart.load();
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });*/
    }

    $.ajax({
      url:'/cart.js',
      type:'GET',
      dataType: "json",
      success: function(data){
        if(data.item_count > 0){
          $.each(data.items, function(key, value){
            var eachitemqty = value.quantity;
            if(uniq_varid==value.id){
              if(eachitemqty<data_qtylimit){
                p_submitform = true;
              } else{
                p_submitform = false;
                $('.p_cart_limit_label').show();
                setTimeout(function(){
                  $('.p_cart_limit_label').hide();
                },2000);
              }
            }
            if(key === data.items.length -1){
              if(p_submitform){
                cartformsubmit()
              }
            }
          });
        } else{
          cartformsubmit()
        }
      }
    });
  }
}
customElements.define('product-form', ProductForm);
